import { render, staticRenderFns } from "./PasswordRequirements.vue?vue&type=template&id=2fd8bb6d"
import script from "./PasswordRequirements.vue?vue&type=script&lang=ts"
export * from "./PasswordRequirements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports